<template>
  <app-page form="xl" class="specialbook-options workspace">
    <form @submit.prevent="onSubmit">
      <div class="d-flex mb-4 pr-4">
        <h1 class="title">オプションを選択して下さい</h1>
        <v-spacer/>
        <v-btn type="submit" color="primary">スキップして次へ</v-btn>
      </div>

      <card-book-car class="mb-4"/>

      <v-card>
        <v-card-text class="text--primary">
          <v-row>
            <v-col cols="12" sm="6">
              <template v-if="m_insurances.length > 0">
                <h2 class="mt-8 mb-3">補償サービス</h2>
                <opt-insurances :opts="opts" :items="selectableInsurances"/>
              </template>

              <template v-if="m_locations.length > 0">
                <h2 class="mt-8 mb-3">ワンウェイサービス</h2>
                <opt-locations :opts="opts" :items="m_locations"/>
              </template>

              <template v-if="m_pick.enabled">
                <h2 class="mt-8 mb-3">送迎オプション</h2>
                <opt-deli :master="m_pick" v-model="opts.pick"/>
              </template>

              <template v-if="m_deli.enabled">
                <h2 class="mt-8 mb-3">配車オプション</h2>
                <opt-deli :master="m_deli" v-model="opts.deli"/>
              </template>
            </v-col>

            <v-col cols="12" sm="6">
              <template v-if="opts.options && m_options.length > 0">
                <h2 class="mt-8 mb-3">オプション</h2>
                <opt-options :master="m_options" :values="opts.options"/>
              </template>

              <template v-if="opts.gears && m_gears.length > 0">
                <h2 class="mt-8 mb-3">レンタルギア</h2>
                <opt-options :master="m_gears" :values="opts.gears"/>
              </template>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-4">
          <v-spacer/>
          <v-btn type="submit" color="primary">次へ</v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </app-page>
</template>

<script>
import ShopBase from '@/app/special/mixins/ShopBase'
import OptInsurances from './OptInsurances'
import OptLocations from './OptLocations'
import OptOptions from './OptOptions'
import OptDeli from './OptDeli'
import CardBookCar from '../BookComponents/CardBookCar'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'BookOptions',
  mixins: [
    ShopBase('オプション選択')
  ],
  components: {
    CardBookCar,
    OptInsurances,
    OptLocations,
    OptOptions,
    OptDeli
  },
  data () {
    return {
      // 入力値
      opts: {
        options: null,
        gears: null,
        discounts: null,
        locationid: 0,
        pick: 0,
        deli: 0,
        insuranceid: 0
      }
    }
  },
  computed: {
    ...mapState('book', {
      s_options: state => state.options,
      s_gears: state => state.gears,
      s_locationid: state => state.locationid,
      s_pick: state => state.pick,
      s_deli: state => state.deli,
      s_insuranceid: state => state.insuranceid
    }),

    ...mapGetters('shop', [
      'm_options',
      'm_gears',
      'm_locations',
      'm_pick',
      'm_deli',
      'm_insurances'
    ]),

    ...mapGetters('book', [
      'selectableInsurances'
    ])
  },
  created () {
    this.addFetcher(() => this.fetch())
  },
  methods: {
    ...mapActions('book', [
      'setBookOption',
      'setBookGear',
      'setBookLocationID',
      'setBookPick',
      'setBookDeli',
      'setBookInsuranceID'
    ]),

    fetch () {
      const options = {}
      for (const id in this.s_options) {
        Object.defineProperty(options, id, {
          get: () => this.s_options[id],
          set: (quantity) => this.setBookOption({ id, quantity })
        })
      }

      const gears = {}
      for (const id in this.s_gears) {
        Object.defineProperty(gears, id, {
          get: () => this.s_gears[id],
          set: (quantity) => this.setBookGear({ id, quantity })
        })
      }

      this.opts.options = options
      this.opts.gears = gears
      this.opts.locationid = this.s_locationid
      this.opts.pick = this.s_pick
      this.opts.deli = this.s_deli
      if (this.selectableInsurances.findIndex(item => item.id === this.s_insuranceid) >= 0) {
        this.opts.insuranceid = this.s_insuranceid
      } else {
        this.opts.insuranceid = this.selectableInsurances[0].id
      }

      return true
    },

    onSubmit () {
      this.setBookLocationID(this.opts.locationid)
      this.setBookPick(this.opts.pick)
      this.setBookDeli(this.opts.deli)
      this.setBookInsuranceID(this.opts.insuranceid)

      // 次のページへ
      this.$router.push({ name: 'book-remark' })
    }
  }
}
</script>
